import { useContext, useState } from 'react';
import Button from '../button/button';
import { Textarea } from '../textarea/textarea';
import { HeartRadio } from '../radio/radio';
import { Checkbox } from '../checkbox/checkbox';
import { fulfillGuestSurvey, runRequestWithToken } from '../../utils/api';
import { UserDataContext } from '../../contexts';

import './form.css';

function Form() {
    const {
      userInfo,
    } = useContext(UserDataContext);
  const { hasPartner, guestSurvey, isPlural = false } = userInfo;
  const hasAnswerDefault = !(guestSurvey?.additionalQuestions === undefined
    && guestSurvey?.willAttend === undefined
    && guestSurvey?.bringPartner === undefined
    && guestSurvey?.useTransfer === undefined
    && guestSurvey?.alcoholPreferences === undefined);

  const [isAttend, setIsAttend] = useState(guestSurvey?.willAttend ?? true);
  const [isWithPartner, setIsWithPartner] = useState(guestSurvey?.bringPartner ?? false);
  const [isUseTransfer, setIsUseTransfer] = useState(guestSurvey?.useTransfer ?? true);
  const [questions, setQuestions] = useState(guestSurvey?.additionalQuestions ?? '');
  const [alcohol, setAlcohol] = useState(guestSurvey?.alcoholPreferences ?? '');

  const [error, setError] = useState<string | undefined>();
  const [hasAnswer, setHasAnswer] = useState<boolean>(hasAnswerDefault);



  const sendSurvey = async (e: any) => {
    e.preventDefault();
    const body = {
      willAttend         : isAttend,
      bringPartner       : isWithPartner,
      useTransfer        : isUseTransfer,
      alcoholPreferences : alcohol,
      additionalQuestions: questions,
    };

    try {
      await runRequestWithToken(fulfillGuestSurvey, body);
      setHasAnswer(true);
    } catch {
      setError('Ошибка при отправке опросника');
    }
  }

  return (
    <section className="guest-form">
      <img src="/images/retro-1.png" alt="" className="retro retro-1"/>
      <img src="/images/retro-2.png" alt="" className="retro retro-2"/>
      <img src="/images/retro-3.png" alt="" className="retro retro-3"/>
      <img src="/images/retro-4.png" alt="" className="retro retro-4"/>
      <img src="/images/retro-5.png" alt="" className="retro retro-5"/>
      <div className="form-paper">
        <div className="form-title-block">
          <div className="form-title">АНКЕТА ГОСТЯ</div>
          {!hasAnswer && <div className="form-subtitle">заполните до 31 июля</div>}
        </div>

        <form>
          <div className="radio-group">
            <HeartRadio
              name="attend"
              value="yes"
              label={isPlural ? "Мы придем 🍆" : "Я приду 🍆"}
              checked={isAttend}
              disabled={hasAnswer}
              onChange={(e) => setIsAttend(Boolean(e.target.value))}
            />

            <HeartRadio
              name="attend"
              value="no"
              label={isPlural ? "Мы не сможем 🥀" : "Я не смогу 🥀" }
              checked={!isAttend}
              disabled={hasAnswer}
              onChange={(e) => setIsAttend(!Boolean(e.target.value))}
            />
          </div>

          {hasPartner &&
            <Checkbox
              name="withPartner"
              value={String(isWithPartner)}
              label="Я буду со своей парой"
              checked={isWithPartner}
              disabled={hasAnswer}
              onChange={(e) => setIsWithPartner(e.target.checked)}
            />
          }

          <Checkbox
            name="transfer"
            value="true"
            label={isPlural ? "Мы воспользуемся трансфером 🚍" : "Я воспользуюсь трансфером 🚍" }
            checked={isUseTransfer}
            disabled={hasAnswer}
            onChange={(e) => setIsUseTransfer(e.target.checked)}
          />

          <Textarea
            label='Алкогольные предпочтения'
            name='alcohol'
            value={alcohol}
            disabled={hasAnswer}
            onChange={(e) => setAlcohol(e.target.value)}
          />
          <Textarea
            label='Место для вопросов (ответим в канале)'
            name='questions'
            value={questions}
            disabled={hasAnswer}
            onChange={(e) => setQuestions(e.target.value)}
          />
          <div className='submit'>
            <Button
              text={ hasAnswer ? "Cпасибо за ответы": 'Отправить ответы' }
              onClick={ sendSurvey }
              disabled={ hasAnswer }
            />
          </div>
        </form>
        {error && <p className='error-text'>{error}</p>}
      </div>
    </section>
  );
}

export default Form;



